<match-display-wrapper
    matchLabel="{{ globalL10nKeys.ipReputationLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <div *ngFor="let reputationType of editable.reputationTypes; trackBy: trackByIndex">
        {{ reputationTypeLabel(reputationType) }}
    </div>
</match-display-wrapper>
